"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enrichLoggerProps = exports.default = void 0;
var _nuiLogger = _interopRequireDefault(require("@concur/nui-logger"));
var _exenv = require("exenv");
var enrichLoggerProps = exports.enrichLoggerProps = function enrichLoggerProps(props) {
  var propSessionId = props.session_id,
    _props$req = props.req;
  _props$req = _props$req === void 0 ? {} : _props$req;
  var _props$req$cookies = _props$req.cookies;
  _props$req$cookies = _props$req$cookies === void 0 ? {} : _props$req$cookies;
  var _props$req$cookies$OT = _props$req$cookies.OTSESSIONAABQRD,
    dSessionId = _props$req$cookies$OT === void 0 ? '' : _props$req$cookies$OT,
    _props$req$cookies$OT2 = _props$req$cookies.OTSESSIONAABQRN,
    oldSessionId = _props$req$cookies$OT2 === void 0 ? '' : _props$req$cookies$OT2,
    _props$req$session = _props$req.session;
  _props$req$session = _props$req$session === void 0 ? {} : _props$req$session;
  var sessionId = _props$req$session.SessionId,
    userUuid = _props$req$session.ConcurId,
    companyUuid = _props$req$session.companyUUID,
    _props$req$proxyUserD = _props$req.proxyUserData,
    proxyUserData = _props$req$proxyUserD === void 0 ? {} : _props$req$proxyUserD,
    url = _props$req.url,
    _props$req$headers = _props$req.headers;
  _props$req$headers = _props$req$headers === void 0 ? {} : _props$req$headers;
  var _props$req$headers$re = _props$req$headers.referer,
    referer = _props$req$headers$re === void 0 ? '' : _props$req$headers$re;
  var delegateUuid = proxyUserData ? proxyUserData.id : null;
  var reqSessionId = (sessionId || oldSessionId || dSessionId).replace(/G/g, '-');
  if (reqSessionId && !propSessionId) {
    //eslint-disable-next-line camelcase
    props.session_id = reqSessionId;
  }

  // temporary hardcoded version
  props.nui_auth_version = '>=6.125.5';
  if (!props.endpoint && url) {
    props.endpoint = url;
  }
  if (props.endpoint && props.endpoint.indexOf('/nui-shell/api/logs') > 0 && referer) {
    props.endpoint = referer;
  }
  if (userUuid) {
    //eslint-disable-next-line camelcase
    props.user_uuid = userUuid;
  }
  if (companyUuid) {
    //eslint-disable-next-line camelcase
    props.company_uuid = companyUuid;
  }
  if (delegateUuid) {
    //eslint-disable-next-line camelcase
    props.delegate_user_uuid = delegateUuid;
  }
  if (_exenv.canUseDOM) {
    if (!props.client_version) {
      var clientVer;
      try {
        //eslint-disable-next-line no-undef
        clientVer = CLIENT_VERSION;
        //eslint-disable-next-line no-empty
      } catch (err) {}
      if (clientVer) {
        //eslint-disable-next-line camelcase
        props.client_version = clientVer;
      }
    }
  } else {
    if (!props.application_version) {
      var appVer = process.env.APPLICATION_VERSION;
      if (appVer) {
        //eslint-disable-next-line camelcase
        props.application_version = appVer;
      }
    }
  }
  return props;
};
var newLogger = {};
['fatal', 'error', 'warn', 'info', 'debug', 'trace'].map(function (method) {
  newLogger[method] = function (props) {
    try {
      _nuiLogger.default[method](enrichLoggerProps(props));
      //eslint-disable-next-line no-empty
    } catch (err) {}
  };
});
var _default = exports.default = newLogger;